export const newPostStyles = {
  container: {
    display: 'flex',
    width: '100%',
    // width: '447px',
    // position: 'fixed',
    // right: '0',
    // bottom: '0',
  },
  expandedInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  textEditorContainer: {
    position: 'relative',
  },
  mentionIndicator: {
    position: 'absolute',
    zIndex: '1',
    width: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: '7px',
  },
  inputContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    // borderTop: '1px solid #F3F4F9',
    backgroundColor: '#F4F5F9',
    gap: '12px',
    padding: '12px 20px',
  },
  minimizeBtnContainer: {
    display: 'flex',
    width: '100%',
    borderBottom: '1px solid #EDEFF7',
    justifyContent: 'center',
  },
  minimizeBtn: {
    display: 'flex',
    minWidth: '56px',
    width: '56px',
    padding: '0',
    backgroundColor: '#FAFBFC',
    borderWidth: '1px',
    borderColor: '#EDEFF7',
    borderStyle: 'solid',
    borderRadius: '8px 8px 0px 0px',
    borderBottom: 'none',
  },
  customAvatar: { width: '36px', height: '36px', borderRadius: '7.2px' },
  userAvatar: {
    display: 'flex',
    backgroundColor: '#EDEFF7',
    borderRadius: '7.2px',
    width: '36px',
    height: '36px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  userInfo: {
    fontFamily: 'Inter',
    color: '#6E707A',
    fontSize: '14px',
    fontStyle: 'normal',
    lineHeight: '146%',
    fontWeight: '500',
    '-webkit-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
  },
  collapsedInputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px',
    cursor: 'pointer',
    width: '100%',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
  },
  collapsedInputPlaceholder: {
    fontFamily: 'Inter',
    color: '#8C8F9D',
    fontSize: '14px',
    fontStyle: 'normal',
    lineHeight: '140%',
    fontWeight: '400',
    '-webkit-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
  },
  collapsedIconsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
  expandedInput: {
    display: 'flex',
    backgroundColor: '#FAFBFC',
    padding: '16px',
    flexDirection: 'column',
    gap: '14px',
    alignItems: 'start',
  },
  addTagsBtn: {
    padding: '4px 0',
    fontFamily: 'Inter',
    fontStyles: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#23252F',
    textTransform: 'unset',
    alignSelf: 'flex-start',
    margin: '8px 0',
  },
  actionsContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  actionBtnsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    justifyContent: 'flex-start',
    label: {
      backgroundColor: '#FFFFFF',
      border: '1px solid #EDEFF7',
      borderRadius: '8px',
      padding: '5px',
      '& svg': {
        width: '24px',
        height: '24px',
      },
    },
  },
  submitBtn: {
    display: 'flex',
    padding: '8px 12px',
    borderRadius: '8px',
    transition: '300ms',
    fontFamily: 'Inter',
    backgroundColor: ' #4D6EF5',
    fontStyles: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#FFFFFF',
    textTransform: 'unset',
    height: '36px',
    border: '1px solid #4d6ef5',
    cursor: 'pointer',
    '&:disabled': {
      color: '#fff',
      opacity: '0.5',
    },
    '&:hover': {
      color: '#4d6ef5',
    },
  },
  cancelBtn: {
    display: 'flex',
    padding: '8px 12px',
    borderRadius: '8px',
    transition: '300ms',
    fontFamily: 'Inter',
    fontStyles: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    backgroundColor: '#FFFFFF',
    color: '#4D6EF5',
    textTransform: 'unset',
    height: '36px',
    border: '1px solid #4D6EF5',
    cursor: 'pointer',
  },
  usersText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    color: '#23252F',
  },
  usersBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '3px 10px',
    gap: '8px',
    background: '#F3F4F9',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  choosedAudienceIcon: { width: '14.67px', height: '13.33px' },
  tagsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexFlow: 'row wrap',
    gap: '6px 8px',
    alignItems: 'center',
    marginTop: '8px',
  },
};
